import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <Button 
          onClick={() => navigate('/')} 
          className="back-button"
          variant="outline"
        >
          <ArrowLeft className="mr-2" />
          Zurück zur Startseite
        </Button>
        
        <h1 className="impressum-title">Impressum</h1>
        
        <div className="impressum-content">
          <p><strong>Sportfreund Cowboy e.U</strong></p>
          <p>Mag. Christian Mannert</p>
          <p>Wiener Straße 21</p>
          <p>7100 Neusiedl am See</p>
          <p>FN: 677254 m</p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
